import {taskTypes} from "./TaskTypes";
const dateTemplate = (value) => {
    if (!value) return "";
    try {
        const date = value instanceof Date ? value : new Date(value);
        return format(date, "dd.MM.yyyy");
    } catch (error) {
        return "";
    }
};
export const editorShape = [
    {
        key: "companySearch",
        type: "text",
        label: "Firma suchen",
        config: {
            placeholder: "Firmennamen eingeben...",
            focus: true,
        },
    },
    {
        key: "start",
        type: "date",
        label: "Start Datum",
        template: dateTemplate,
    },
    {
        key: "end",
        type: "date",
        label: "End Datum",
        template: dateTemplate,
    },
    {
        key: "details",
        type: "textarea",
        label: "Zusätzliche Informationen",
        config: {
            placeholder: "Weitere Details zum MA-Beratungslauf",
        },
    },
];
